import React from "react";
import { Link } from "react-router-dom";
import { useCalculatorEnabled } from "@/hooks/use-calculator-enabled";
import { Logo } from "@/components/Logo";

export const PublicFooter = () => {
  const calcEnabled = useCalculatorEnabled();
  return (
    <footer className="dark-section relative overflow-hidden pg-noise">
      <div className="pg-container relative px-4 py-14 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12 md:gap-8">
          <div className="md:col-span-5 lg:col-span-5">
            <Logo dark size="text-[22px]" />
            <p className="mt-4 max-w-xs text-sm text-slate-300">
              An independent scientific brand. Precision-focused solutions with documentation-first
              transparency.
            </p>
          </div>
          <div className="md:col-span-3">
            <h4 className="font-heading text-sm font-semibold text-white">Explore</h4>
            <ul className="mt-4 space-y-2 text-sm text-slate-300">
              <li><Link to="/products" className="hover:text-brand-cyan">Products</Link></li>
              <li><Link to="/about" className="hover:text-brand-cyan">About PEPTIGENIE</Link></li>
              <li><Link to="/quality" className="hover:text-brand-cyan">Quality & Documentation</Link></li>
              {calcEnabled && <li><Link to="/calculator" className="hover:text-brand-cyan">Reconstitution Calculator</Link></li>}
              <li><Link to="/membership" className="hover:text-brand-cyan">Membership</Link></li>
            </ul>
          </div>
          <div className="md:col-span-2">
            <h4 className="font-heading text-sm font-semibold text-white">Legal</h4>
            <ul className="mt-4 space-y-2 text-sm text-slate-300">
              <li><Link to="/legal/privacy-policy" className="hover:text-brand-cyan">Privacy Policy</Link></li>
              <li><Link to="/legal/terms-and-conditions" className="hover:text-brand-cyan">Terms & Conditions</Link></li>
              <li><Link to="/legal/membership-terms" className="hover:text-brand-cyan">Membership Terms</Link></li>
              <li><Link to="/legal/regulatory-information" className="hover:text-brand-cyan">Regulatory Information</Link></li>
            </ul>
          </div>
          <div className="md:col-span-2">
            <h4 className="font-heading text-sm font-semibold text-white">Access</h4>
            <ul className="mt-4 space-y-2 text-sm text-slate-300">
              <li><Link to="/login" className="hover:text-brand-cyan">Member Login</Link></li>
              <li><Link to="/membership" className="hover:text-brand-cyan">Apply for Membership</Link></li>
              <li><Link to="/contact" className="hover:text-brand-cyan">Contact</Link></li>
            </ul>
          </div>
        </div>
        <div className="mt-12 border-t border-white/10 pt-6">
          <p className="text-xs text-slate-400">
            © {new Date().getFullYear()} PEPTIGENIE. All rights reserved. Product availability and information are
            subject to regulatory classification and jurisdictional requirements. Nothing on this site constitutes
            medical advice or an offer to supply restricted goods where prohibited.
          </p>
        </div>
      </div>
    </footer>
  );
};
